import React, { useState, useContext, useEffect, Fragment, useCallback, useRef } from 'react';
import "../../../ui-styles/conference/confFooter.css";
import "../../../ui-styles/tooltips/tooltips.css";
// import { getInvitees } from '../../../actions/schedule';
import ConfResNav from "./ConfResNav";
import ConfResOverlay from "./ConfResOverlay";
import PatientVisitSlide from "./PatientVisitSlide";
import ConfInviteSlide from "./ConfInviteSlide";
import ChatSlide from "./ChatSlide";
import { LangCtx, InstavcCtx, RoleCtx, localRecordingCtx } from "../../../lib/context";
import PrescriptionSlide from './PrescriptionSlide';
import InternalNote from './internalNote';
import PatientHistory from './patientHistory';

const ConfFooter = (props) => {
    console.log("conf footer props are ................ ", props);
    const { l } = useContext(LangCtx);
    const { instaVC } = useContext(InstavcCtx);
    const { role } = useContext(RoleCtx);
    const record = useContext(localRecordingCtx);
    const [muteAudio, setMuteAudio] = useState(false);
    const [hideVideo, setHideVideo] = useState(false);
    const [patientSlide, setPatientSlide] = useState(false);
    const [confInvite, setConfInvite] = useState(false);

    const [slideNav, setSlideNav] = useState(false);
    const [fadeOverlay, setFadeOverlay] = useState(false);

    const [chatSlide, setChatSlide] = useState(false);
    const [prescSlide, setPrescSlide] = useState(false);
    const [inNotes, setInNotes] = useState(false)
    const [inHistory, setInHistory] = useState(false)
    const [activeSlide, setActiveSlide] = useState(null);
    const [chatCount, setChatCount] = useState(0);
    const chatCountRef = useRef(chatCount);
    const { payload, name, email, data } = props;

    const processMessage = useCallback((msg) => {

        if(msg.data.message ==='GROUPCHAT'){
            if (msg.data && ((payload && msg.data.userId !== payload.userId) || msg.data.userId !== email) && !chatSlide) {
                chatCountRef.current += 1;
                setChatCount(chatCountRef.current);
            } else {
                chatCountRef.current = 0;
                setChatCount(0);
            }
        }
    }, []);
    

    useEffect(() => {
        instaVC.addEventListener('message-received', processMessage);
        return function cleanup() {
            instaVC.removeEventListener('message-received',processMessage);
        }
    }, [instaVC]);


    
    const handleSlideNav = () => {
        setSlideNav(prevState => !prevState);
        setFadeOverlay(prevState => !prevState);
    }
    const handleMute = () => {
        if (instaVC._micProducer) {
            if (!instaVC._micProducer.paused) {
                instaVC.muteMic();
            }
            else {
                instaVC.unmuteMic();
            }
            setMuteAudio(prevState => !prevState);
        }

    }
    const handleHide = () => {
        if (instaVC._webcamProducer) {

            instaVC.disableWebcam();

        }
        else {
            instaVC.updateWebcam({ start: true });

        }
        setHideVideo(prevState => !prevState);

    }

    const handleTabSwitch = (tab) => {
        setActiveSlide(prevTab => (prevTab === tab ? null : tab));
    }
    const handleSlide = () => {
        setPatientSlide(prevState => !prevState);
        setSlideNav(false);
        setFadeOverlay(false);
        setChatSlide(false);
    }
    const handleConfInvite = () => {
        setConfInvite(prevState => !prevState);
        setSlideNav(false);
        setFadeOverlay(false);
    }
    const handlePrescSlide = () => {
        setPrescSlide(prevState => !prevState);
        setPatientSlide(false);
        setSlideNav(false);
        setFadeOverlay(false)
    }

    const handleNotes = () => {
        setInNotes(prevState => !prevState);
        setSlideNav(false);
        setFadeOverlay(false);
        setChatSlide(false);
    }

    const handlePatientHistory = () => {
        setInHistory(prevState => !prevState);
        setSlideNav(false);
        setFadeOverlay(false);
    }

    const handleChatSlide = () => {
        setChatSlide(prevState => !prevState);
        chatCountRef.current = 0;
        setChatCount(0);
        setSlideNav(false);
        setFadeOverlay(false);
        handleTabSwitch('chat');
    }

    const handleScreenShare = () => {
        setSlideNav(false);
        setFadeOverlay(false);
        props.handleScreenShare()
    }

    const handleWhiteBoard = () => {
        setSlideNav(false);
        setFadeOverlay(false);
        if(props.currentScreen === "WB"){
            props.handleScreen("CLOSESCREEN");
        } else {
            props.handleScreen("OPENWB");
        }
        // let ele = document.getElementById("videoArea");
        // if (ele) {
        //     ele.className += " ssbtmVideos";
        // }
    }

    console.log('................', record);


    return (
        <Fragment>
            <div className="confFooter">
                <div className="confRowBlock">
                    <div className="confFtrToolsRow">
                        <div className="confToolsCntr">
                            <div className="confToolBox confDtnBg active" onClick={handleMute} tooltip={muteAudio ? "Unmute" : "Mute"}>
                                <span className={muteAudio ? "muteLine" : "muteLine hideLine"} />
                                <img src="/images/icons/microphone.png" alt="icon" className="invertWhite" />
                            </div>
                            <div className="confToolBox confDtnBg active" onClick={handleHide} tooltip={hideVideo ? "Show Video" : "Hide Video"}>
                                <span className={hideVideo ? "muteLine" : "muteLine hideLine"} />
                                <img src="/images/icons/video-cam.png" alt="icon" className="invertWhite" />
                            </div>
                            {/* {role === "D" ? */}
                            <div className="confToolBox endBg active endCallClass" onClick={props.handleEndCall} tooltip={"End Call"}>
                                <img src="/images/icons/phone.png" alt="icon" className="invertWhite" />
                            </div>

                            {/* <div className="confToolBox endBg active" onClick={props.handleEndCall}>
                                <img src="/images/icons/phone.png" alt="icon" className="invertWhite" />
                            </div> */}

                            <div className="confToolBox confDtnBg active showChat" tooltip={l.chat} onClick={handleChatSlide}>
                                <img src="/images/icons/group-chat.png" alt="icon" className="invertWhite" />
                                {chatCount > 0 && <div className="badgeCounter">
                                    <small>{chatCount}</small>
                                </div>}
                            </div>

                        </div>

                        <div className="absltToolBox rightEnd">
                            {role === "D" && <Fragment>
                                <div className="confToolBox hdlMrgn4" tooltip={l.pat_details} onClick={handleSlide}>
                                    <img src="/images/icons/medical-reports-outline.png" alt="icon" className="invertWhite" />
                                </div>
                                <div className="confToolBox hdlMrgn4 active" tooltip={l.notes} onClick={handleNotes}>
                                    <img src="/images/icons/notes.png" alt="icon" className="invertWhite" />
                                </div>
                                {/* {props.currentScreen === "SSS" ?
                                    <div className="confToolBox hdlMrgn4 active" tooltip={l.stop_ss} onClick={()=>{handleScreenShare()}}>
                                        <img src="/images/icons/stop-screenshare.png" alt="icon" />
                                    </div>
                                    :
                                    <div className="confToolBox hdlMrgn4" tooltip={l.screen_share} onClick={()=>{handleScreenShare()}}>
                                        <img src="/images/icons/screen-share.png" alt="icon" className="invertWhite" />
                                    </div>} */}
                                {props.currentScreen === "SSS" ? (
                                    <div
                                        className="confToolBox hdlMrgn4 active"
                                        tooltip={l.stop_ss}
                                        onClick={handleScreenShare}
                                    >
                                        <img src="/images/icons/stop-screenshare.png" alt="Stop Screen Share Icon" />
                                    </div>
                                ) : (
                                    <div
                                        className="confToolBox hdlMrgn4"
                                        tooltip={l.screen_share}
                                        onClick={handleScreenShare}
                                    >
                                        <img src="/images/icons/screen-share.png" alt="Start Screen Share Icon" className="invertWhite" />
                                    </div>
                                )}


                                {props.currentScreen === "WB" ?
                                    <div className="confToolBox hdlMrgn4 activeWhiteboard" tooltip={l.stop_wb} onClick={handleWhiteBoard}>
                                        <img src="/images/icons/whiteboard-outline.png" alt="icon" className="invertWhite" />
                                    </div>
                                    : <div className="confToolBox hdlMrgn4" tooltip={l.whiteboard} onClick={handleWhiteBoard}>
                                        <img src="/images/icons/whiteboard-outline.png" alt="icon" className="invertWhite" />
                                    </div>}
                                <div className="confToolBox hdlMrgn4" tooltip={l.invite} onClick={handleConfInvite}>
                                    <img src="/images/icons/invite.png" alt="icon" className="invertWhite" />
                                </div>
                                {props.data?.clinicData?.cloudRecordings === true && <div
                                    className="confToolBox hdlMrgn4"
                                    tooltip={record.cloudRecording ? "Stop Cloud Recording" : "Start Cloud Recording"}
                                    onClick={record.cloudRecording ? () => record.stopCloudRecording() : () => record.startCloudRecording()}
                                >
                                    <img
                                        src={record.cloudRecording ? "/images/cloudRecordingOff.svg" : "/images/cloudRecording.svg"}
                                        alt="icon"
                                        className="invertWhite"
                                    />
                                </div>}
                                {props.data?.clinicData?.localRecordings === true && <div
                                    className="confToolBox hdlMrgn4"
                                    tooltip={record.localRecording ? "Stop Local Recording" : "Start Local Recording"}
                                    onClick={record.localRecording ? () => record.stopRecording() : () => record.startLocalRecording()}
                                >
                                    <img
                                        src={record.localRecording ? "/images/stopRecording.svg" : "/images/localRecording.svg"}
                                        alt="icon"
                                        className="invertWhite"
                                    />
                                </div>}
                            </Fragment>}
                            {(role === "P" || role === "D") &&
                                <>
                                    <div className="confToolBox hdlMrgn4 active" tooltip={l.presc} onClick={handlePrescSlide}>
                                        <img src="/images/icons/prescription-outline.png" alt="icon" className="invertWhite" />
                                    </div>
                                    <div className="confToolBox hdlMrgn4 active" tooltip="Patient History" onClick={handlePatientHistory}>
                                        <img src="/images/icons/history.png" alt="icon" className="invertWhite" />
                                    </div>
                                </>}
                            {(role === "P" || role === "D" || role === "CA" || role === "C" || role === "SA") && <div className="confToolBox hdlMrgn4" tooltip={l.chat} onClick={handleChatSlide}>
                                <img src="/images/icons/group-chat.png" alt="icon" className="invertWhite" />
                                {chatCount > 0 && <div className="badgeCounter">
                                    <small>{chatCount}</small>
                                </div>}
                            </div>}
                        </div>

                        {/* RESPONSIVE NAV */}
                        {role === "D" &&
                            <div className="resConfNav" onClick={handleSlideNav}>
                                <div className="dotNav">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        }
                        {role !== "D" &&
                            <div className="resConfNav" onClick={handleSlideNav}>
                                 <div className="dotNav">
                                {/* <div className="confToolBox hdlMrgn4 active" tooltip={l.presc} onClick={handlePrescSlide}>
                                    <img src="/images/icons/prescription-outline.png" alt="icon" className="invertWhite" /> */}
                                {/* </div> */}
                                <span></span>
                                    <span></span>
                                    <span></span>
                            </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {slideNav && <ConfResNav
                slideNav={slideNav}
                slideOut={handleSlideNav}
                openPatientSlide={handleSlide}
                openConfInvite={handleConfInvite}
                openinternalNotes={handleNotes}
                openPatientHistory={handlePatientHistory}
                handleScreenShare={handleScreenShare}
                handleWhiteBoard={handleWhiteBoard}
                openSlide={handlePrescSlide}
                appointmentData={props.data}
                // handleChatSlide={handleChatSlide}
                role={role}
            />}
            {fadeOverlay && <ConfResOverlay fadeOverlay={fadeOverlay} slideOut={handleSlideNav} />}
            {patientSlide && <PatientVisitSlide patientSlide={patientSlide} close={handleSlide} data={props.data} />}
            {confInvite && <ConfInviteSlide confInvite={confInvite} close={handleConfInvite} data={props.data} />}
            {prescSlide && <PrescriptionSlide openSlide={prescSlide} closePresc={handlePrescSlide} data={props.data} type={"conf"} />}
            {chatSlide && <ChatSlide chatSlide={chatSlide} name={name} email={email} handleChatSlide={handleChatSlide} />}
            {inNotes && <InternalNote inNotes={inNotes} close={handleNotes} data={data} />}
            {inHistory && <PatientHistory patientHistory={inHistory} close={handlePatientHistory} data={data} role={role}/>}
        </Fragment>
    )
}

export default ConfFooter;